export const name = 'rnOrganization';
export default function rnOrganization($q, $log, $filter, rnHttp, rnRecordFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const AAA_SERVICE_NAME = 'aaa';
  const ORG_ORGANIZATIONS_PATH = 'organizations';
  const ORG_APPLICATIONS_PATH = 'organizations/applications/';
  const ORG_PACKAGES_PATH = 'organizations/packages/';
  const ORG_PACKAGEAPPLOG_PATH = 'organizations/packageapplog/';
  const ORG_USERS_PATH = 'organizations/users/';
  const ORG_SUMMARY_PATH = 'organizations/summary';
  const ORG_GRANTED_SHARES_PATH = 'organizations/grantedshares/';

  let service = {
    getPackage: getPackage,
    getApplications: getApplications,
    getPackageapplog : getPackageapplog,
    getOrganization: getOrganization,
    setOrganization: setOrganization,
    setActive: setActive,
    getSummary: getSummary,
    getGrantedOrgs: getGrantedOrgs,
    testObject: {
      cleanPath: cleanPath
    }
  };

  return service;

  ////////////////

  function getPackage() {

    return doGet(AAA_SERVICE_NAME, ORG_PACKAGES_PATH)
      .then(function(packageData) {
        let packageRecord = createRecord(packageData);
        return $q.resolve(packageRecord);
      });
  }

  function getApplications() {

    return doGet(AAA_SERVICE_NAME, ORG_APPLICATIONS_PATH)
      .then(function(appsCollection) {
        let appsRecords = _.map(appsCollection.applications, createRecord);
        appsCollection.applications = appsRecords;
        return appsCollection.data;
      });
  }


  function getPackageapplog() {
    return doGet(AAA_SERVICE_NAME, ORG_PACKAGEAPPLOG_PATH)
      .then(function(logsCollection) {
        let logRecords = _.map(logsCollection.logs, createRecord);
        logsCollection.logs = logRecords;
        return $q.resolve(logsCollection);
      });
  }


  function createRecord(data) {
    let record = rnRecordFactory.create(data);
    return record;
  }

  function setActive(userId, active) {
    let path = ORG_USERS_PATH + userId + '/active/';

    return doAaaPut(path, active);
  }

  function doAaaPut(path, content) {
    return rnHttp.put(AAA_SERVICE_NAME, path, content);
  }

  function getOrganization(cache = true) {
    // Should be safe to cache in memory
    return rnHttp.get(AAA_SERVICE_NAME, ORG_ORGANIZATIONS_PATH, { cache });
  }

  function setOrganization(org) {
    return doAaaPut(ORG_ORGANIZATIONS_PATH, org);
  }

  function getSummary() {
    return rnHttp.get(AAA_SERVICE_NAME, ORG_SUMMARY_PATH);
  }

  function getGrantedOrgs() {
    return rnHttp.get(AAA_SERVICE_NAME, ORG_GRANTED_SHARES_PATH);
  }

  function doGet(service, path, config) {
    // Annoying but necessary as we are working with both absolute and relative URLs for AAA services. This doesn't
    // occur with other services in this service but if it does we will need to split this into service specific functions
    // so we can test for all cases.
    if (path.indexOf('/api/aaa/v1/') >= 0) {
      path = cleanPath(path);
    }

    return rnHttp.get(service, path, config);
  }

  function cleanPath(dirty) {
    var start = dirty.indexOf('organizations');
    var end = dirty.length;
    var clean = dirty.substring(start, end);

    return clean;
  }
}
